"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClaimAssignmentValidator = exports.claimAssignmentSchema = void 0;
var schema_validator_1 = require("@hobt/schema-validator");
exports.claimAssignmentSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['claimID', 'adjudicatorUserID'],
    properties: {
        claimID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
        adjudicatorUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
    },
};
exports.getClaimAssignmentValidator = function () {
    return new schema_validator_1.SchemaValidator(exports.claimAssignmentSchema, true, true, true, true);
};
